import { Flex, Text, Tag } from "@chakra-ui/react";
import { useMemo } from "react";
import { RetornoBancariaPaginate } from "core/features/retorno-bancario/typings";
import moment from "moment";
import colors from "core/resources/theme/colors";
import {AiOutlineCalendar} from 'react-icons/ai'

function useRetornoBancarioColumns() {
  return useMemo(() => {
    return [
      {
        title: "Arquivos",
        render: (item: RetornoBancariaPaginate) => {
          return (
            <Flex flexDir="column">
              <Flex>
                <Text fontWeight="bold">
                  {item.banco.nome}
                </Text>{" "}
                - arquivo {item.nome}
              </Flex>
              <Flex>Processado em {moment(item.createdAt).calendar()}</Flex>
            </Flex>
          );
        },
      },
      {
        title: "",
        render: (item: RetornoBancariaPaginate) => {
          return (
            <Tag gap="6px" color={colors.blue500} bg={colors.blue200}>
              <AiOutlineCalendar />
              Arquivo de {moment(item.dataReferencia).format("DD/MM/YYYY")}
            </Tag>
          );
        },
      },
      {
        title: "",
        render: (item: RetornoBancariaPaginate) => {
          return (
            <Tag color="white" bg={colors.primaryLight}>
              {item.trailer?.quantidadeTitulos ?? 0}{" "}
              {+item.trailer?.quantidadeTitulos! === 1 ? "item" : "itens"}
            </Tag>
          );
        },
      },
    ];
  }, []);
}

export default useRetornoBancarioColumns;
